import React from 'react'
import { Redirect } from 'react-router-dom'

export const isMobile = () => {
  return (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  )
}

export default class DetectDevicePage extends React.Component {
  detectMobile() {
    return isMobile()
  }

  render() {
    // return <Redirect to="/login" />

    if (this.detectMobile()) {
      return (
        <Redirect
          to={{
            pathname: '/menu',
          }}
        />
      )
    } else {
      return (
        <Redirect
          to={{
            pathname: '/menu',
          }}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/DetectDevicePage.js